import { FC, ReactNode } from 'react';
import { BaseButtonProps } from 'antd/es/button/button';
import Tooltip from '../Tooltip';
import styles from './ButtonDrawer.module.scss';

export interface IButtonDrawerProps extends BaseButtonProps {
  style?: any;
  placement: string;
  children: ReactNode;
  border?: boolean;
  delay?: boolean;
  hideHover?: boolean;
  onClick: () => void;
}

const ButtonDrawer: FC<IButtonDrawerProps> = ({
  style,
  placement,
  children,
  border,
  delay,
  hideHover,
  onClick,
}) => {
  return (
    <Tooltip
      title={placement}
      placement="right"
      mouseEnterDelay={delay ? 2 : undefined}
    >
      <button
        onClick={() => onClick()}
        className={`
            ${styles['buttonWrapper']} 
            ${border ? styles['border'] : ''}
            ${hideHover ? styles['hideHover'] : ''}
          `}
        style={{ ...style }}
      >
        {children}
      </button>
    </Tooltip>
  );
};

export default ButtonDrawer;
